module.exports = __webpack_public_path__ + "static/stepbg-58a0be4c4146a32bdf5918db07725a6c.png";